import { Box, Card, CardContent, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

interface FilterContainerProps {
  children: ReactNode;
  title?: string;
  onSubmit?: (e: React.FormEvent) => void;
  sx?: Record<string, unknown>;
}

/**
 * Generic filter container component
 * Common container that wraps various filter condition input UIs
 */
export const FilterContainer: React.FC<FilterContainerProps> = ({
  children,
  title,
  onSubmit,
  sx = {},
}) => {
  const content = (
    <>
      {title && (
        <Typography variant="h6" sx={{ mb: 2 }}>
          {title}
        </Typography>
      )}
      {children}
    </>
  );

  if (onSubmit) {
    return (
      <Box component="form" onSubmit={onSubmit} sx={{ mb: 3, ...sx }}>
        {content}
      </Box>
    );
  }

  return (
    <Card sx={{ mb: 4, ...sx }}>
      <CardContent>
        {content}
      </CardContent>
    </Card>
  );
};

export default FilterContainer;
